import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_skill-bridge-hr/artifacts/gxk71j6k_free-photo-of-a-group-of-people-standing-in-a-circle-removebg-preview.png";

const serviceLinks = [
  { label: "Permanent Staffing", path: "/services" },
  { label: "Contract Staffing", path: "/services" },
  { label: "Executive Search", path: "/services" },
  { label: "Bulk Recruitment", path: "/services" },
  { label: "HR Consulting", path: "/services" },
  { label: "Payroll Management", path: "/services" },
];

const companyLinks = [
  { label: "About Us", path: "/about" },
  { label: "For Employers", path: "/employers" },
  { label: "Careers", path: "/careers" },
  { label: "Contact", path: "/contact" },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0D2E54] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          {/* Logo & description */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <img src={LOGO_URL} alt="Skill Bridge HR" className="h-12 w-auto" />
              <div>
                <span className="font-heading font-bold text-white text-lg block">SKILL BRIDGE</span>
                <span className="font-heading text-blue-300 text-[10px] tracking-[0.15em] uppercase block">Human Resources Pvt. Ltd.</span>
              </div>
            </Link>
            <p className="text-blue-200 text-sm leading-relaxed mb-6">
              India's trusted HR partner — bridging talent with opportunity across 15+ industries with precision, speed, and compliance.
            </p>
            <div className="flex items-center gap-4">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" data-testid="social-linkedin" className="w-9 h-9 bg-white/10 flex items-center justify-center hover:bg-[var(--sb-blue)] transition-colors" aria-label="LinkedIn">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" data-testid="social-facebook" className="w-9 h-9 bg-white/10 flex items-center justify-center hover:bg-[var(--sb-blue)] transition-colors" aria-label="Facebook">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" data-testid="social-instagram" className="w-9 h-9 bg-white/10 flex items-center justify-center hover:bg-[var(--sb-blue)] transition-colors" aria-label="Instagram">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-bold text-lg uppercase tracking-wide mb-5">Services</h4>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-blue-200 text-sm hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading font-bold text-lg uppercase tracking-wide mb-5">Company</h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.path} className="text-blue-200 text-sm hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-lg uppercase tracking-wide mb-5">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[var(--sb-orange)] mt-0.5 flex-shrink-0" />
                <a href="tel:+919214463185" className="text-blue-200 text-sm hover:text-white transition-colors">+91 92144 63185</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[var(--sb-orange)] mt-0.5 flex-shrink-0" />
                <div className="flex flex-col">
                  <a href="mailto:info@skillsbridge.co.in" className="text-blue-200 text-sm hover:text-white transition-colors">info@skillsbridge.co.in</a>
                  <a href="mailto:hr@skillsbridge.co.in" className="text-blue-200 text-sm hover:text-white transition-colors">hr@skillsbridge.co.in</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[var(--sb-orange)] mt-0.5 flex-shrink-0" />
                <span className="text-blue-200 text-sm">India</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-6">
          <p className="text-blue-300 text-sm text-center">
            &copy; {new Date().getFullYear()} Skill Bridge Human Resources Private Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
